import { render, staticRenderFns } from "./VoucherWorkToDo.vue?vue&type=template&id=d4b3d746&"
import script from "./VoucherWorkToDo.vue?vue&type=script&lang=js&"
export * from "./VoucherWorkToDo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4b3d746')) {
      api.createRecord('d4b3d746', component.options)
    } else {
      api.reload('d4b3d746', component.options)
    }
    module.hot.accept("./VoucherWorkToDo.vue?vue&type=template&id=d4b3d746&", function () {
      api.rerender('d4b3d746', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/VoucherWorkToDo.vue"
export default component.exports